module.exports = __webpack_public_path__ + "static/media/firebase.7f8d489c.svg";